// Formattazione delle date in GG/MM/AAAA.
// - Le date "pure" (colonne DATE, es. data_assunzione) arrivano come testo AAAA-MM-GG:
//   si formattano dal testo, senza passare dal fuso orario del browser.
// - Gli istanti (timestamp, es. data di invio) si mostrano nel fuso dello studio.
export function formattaData(valore) {
  if (!valore) return '';
  const testo = typeof valore === 'string' ? valore.match(/^(\d{4})-(\d{2})-(\d{2})$/) : null;
  if (testo) return `${testo[3]}/${testo[2]}/${testo[1]}`;
  return new Date(valore).toLocaleDateString('it-IT', { day: '2-digit', month: '2-digit', year: 'numeric', timeZone: 'Europe/Rome' });
}

// Valore per <input type="date"> (AAAA-MM-GG)
export function perInputData(valore) {
  if (!valore) return '';
  return String(valore).slice(0, 10);
}
